import { useEffect, useState } from "react";

function WeatherWidget() {
  const [weather, setWeather] = useState(null);
  const API_KEY = "06125c9b78fd4f288b2124124253101"; // Замените на ваш API-ключ
  const lat = 30.686303770248195;
  const lon = -88.15458256462044;

  useEffect(() => {
    fetch(
      `https://api.weatherapi.com/v1/current.json?key=${API_KEY}&q=${lat},${lon}&aqi=no`,
    )
      .then((response) => response.json())
      .then((data) => setWeather(data.current))
      .catch((error) => console.error("Error fetching weather data:", error));
  }, []);

  if (!weather) {
    return <div style={{ color: "white" }}>Loading...</div>;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        // backgroundColor: "rgba(0, 0, 0, 0.5)",
        // padding: "16px",
        // borderRadius: "8px",
        color: "white",
        width: "200px",
      }}
    >
      <img
        src={weather.condition.icon}
        alt={weather.condition.text}
        style={{ width: "40px", height: "40px", marginRight: "8px" }}
      />
      <div>
        <div style={{ fontSize: "24px", fontWeight: "bold" }}>
          {weather.temp_f}°F
        </div>
        <div style={{ fontSize: "14px" }}>
          Wind: {weather.wind_mph} mph {weather.wind_dir}
        </div>
      </div>
    </div>
  );
}

export { WeatherWidget };
